module.exports = __webpack_public_path__ + "img/standard.ff4f2c85.png";